<template>
  <div class="stage stage-video">
    <VideoWrapper
      v-if="activeVideo"
      ref="video"
      :source="activeVideo.src"
      :chapter="activeVideo.chapter"
      @ended="onEnded"
      @action="onAction(activeVideo.ended)"
    />

    <h1
      v-if="stage.heading"
      class="stage-heading"
      v-html="stage.heading"
    ></h1>

    <ButtonGroup
      v-if="stage.options.length > 0"
      v-show="!playing"
      ref="button-group"
      :buttons="stage.options"
      :disableOnPress="true"
      @action="onAction"
    />

    <ButtonMedicalRecords v-if="stage['records-button']" v-show="!playing" @action="onAction" />  

    <BasePopup
      v-if="activePopup"
      :key="popupIndex"
      :popup="activePopup"
      @action="onAction"
    />
  </div>
</template>

<script>
import BasePopup from '../popups/BasePopup.vue'
import ButtonGroup from '../partials/ButtonGroup.vue'
import ButtonMedicalRecords from '../partials/ButtonMedicalRecords.vue'
import VideoWrapper from '../partials/VideoWrapper.vue'

export default {
  name: 'StageVideoAll',
  components: {
    BasePopup,
    ButtonGroup,
    ButtonMedicalRecords,
    VideoWrapper,
  },
  props: {
    stage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activePopup : null,
      popupIndex: -1,

      videoBuffer: null,
      activeVideo: null,
      disableOnPlay: true,
      playing: false,

      watched: [],

      eventHandlers: {
        'on-ended': this.onEnded,
        'play-video': this.playVideo,
        'show-popup': this.showPopup,
        'close-popup': this.hidePopup,
        'check-state': this.checkState,
      },
    }
  },
  methods: {
    reset() {
      this.$refs['button-group'].reset();
      this.$refs['video'].reset();
    },

    onAction(event) {
      if (event.type in this.eventHandlers) {
        this.eventHandlers[event.type](event);
      } else {
        this.$emit('action', event);
      }
    },
    gotoStage(event) {
      this.activePopup = null;
      this.$emit('action', event);
    },
    onEnded() {
      this.playing = false;
    },
    playVideo(event) {
      this.activeVideo = null;
      this.activeVideo = event;
      this.playing = true;

      if (this.watched.indexOf(this.activeVideo.src) < 0) {
        this.watched.push(this.activeVideo.src);
      }
    },
    pauseVideo() {
      if (this.activeVideo) {
        this.$refs['video'].pause();
      }
    },
    showPopup(event) {
      this.activePopup = this.stage.popups[event.popup] || null;
      this.popupIndex += 1;
    },
    hidePopup(event) {
      this.activePopup = null;

      if (event.reset) {
        this.reset();
      }
    },
    checkState() {
      if (this.watched.length >= this.stage.options.length) {
        this.onAction({ type: 'show-popup', popup: 0 });
      }
    },
  },
  mounted() {
    if (this.stage.onload) {
      this.disableOnPlay = false; // Temporary fix.
      this.onAction(this.stage.onload);
    }
  },
}
</script>
